// so we could use both immutable.js objects and regular objects

export function _get<
  TObject extends object,
  TKey extends keyof TObject,
  TValue,
>(object: TObject, key: TKey): TValue {
  return !('get' in object) || typeof object.get !== 'function'
    ? object[key]
    : object.get(key);
}

export function _length(object: { count?: () => number; length: number }) {
  return typeof object.count === 'function' ? object.count() : object.length;
}

export function arraysEqual<T>(array1?: Array<T>, array2?: Array<T>) {
  return (
    array1 &&
    array2 &&
    _length(array1) === _length(array2) &&
    array1.every((element, index) => {
      return element === _get(array2, index);
    })
  );
}

export function keyBy<
  Key extends string | number,
  Elements extends object & {
    [Property in Key]: string | number;
  },
>(value: Array<Elements>, key: Key) {
  const obj: Record<string, Elements> = {};

  value.forEach(function (element) {
    obj[element[key] as string] = element;
  });

  return obj;
}

export function noop() {}
